/* =============================================================
   ATV — Atelier de la Vigne · theme.js
   Vanilla JS — pas de framework. Cible navigateurs modernes.
   ============================================================= */

(function () {
  'use strict';

  // ─── Mobile drawer ───────────────────────────────────────────
  const drawer = document.querySelector('[data-mobile-drawer]');
  const openBtns = document.querySelectorAll('[data-open-drawer]');
  const closeBtns = document.querySelectorAll('[data-close-drawer]');

  if (drawer) {
    openBtns.forEach((b) => b.addEventListener('click', () => drawer.classList.add('is-open')));
    closeBtns.forEach((b) => b.addEventListener('click', () => drawer.classList.remove('is-open')));
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) drawer.classList.remove('is-open');
    });
  }

  // ─── Quantity inputs ────────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    const action = btn.dataset.qty; // 'plus' | 'minus'
    const wrap = btn.closest('[data-qty-wrap]');
    if (!wrap) return;
    const input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    const min = parseInt(input.min || '1', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value || '1', 10);
    v = action === 'plus' ? v + 1 : v - 1;
    if (v < min) v = min;
    if (v > max) v = max;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ─── Cart count update helper ──────────────────────────────
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.setAttribute('data-cart-count', count);
      el.textContent = count;
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((c) => {
        updateCartCount(c.item_count);
        return c;
      });
  }

  // ─── Cart line item quantity update (cart page) ─────────────
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    const line = input.dataset.line;
    const qty = parseInt(input.value || '0', 10);
    if (Number.isNaN(line) || Number.isNaN(qty)) return;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty }),
    })
      .then((r) => r.json())
      .then(() => {
        // Reload to reflect new totals — simpler than partial refresh and
        // still sub-second on the cart page.
        window.location.reload();
      })
      .catch(() => window.location.reload());
  });

  // ─── Cart item remove ──────────────────────────────────────
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.dataset.cartRemove, 10);
    if (Number.isNaN(line)) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: 0 }),
    }).then(() => window.location.reload());
  });

  // ─── Add to cart from product page ──────────────────────────
  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = productForm.querySelector('[type="submit"]');
      const originalLabel = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.innerHTML = 'Ajout en cours…';
      }

      const formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      })
        .then((r) => {
          if (!r.ok) throw new Error('add_failed');
          return r.json();
        })
        .then(() => fetchCart())
        .then(() => {
          if (submitBtn) {
            submitBtn.innerHTML = '✓ Ajouté au panier';
            setTimeout(() => {
              submitBtn.disabled = false;
              submitBtn.innerHTML = originalLabel;
            }, 1800);
          }
        })
        .catch(() => {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalLabel;
          }
          alert("Impossible d'ajouter au panier. Réessayez ou appelez l'atelier.");
        });
    });
  }

  // ─── Product gallery thumbnails ────────────────────────────
  const galleryMain = document.querySelector('[data-gallery-main]');
  const galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  if (galleryMain && galleryThumbs.length) {
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        const src = thumb.dataset.galleryThumb;
        const alt = thumb.dataset.galleryAlt || '';
        if (!src) return;
        galleryMain.innerHTML = `<img class="product-gallery__main-img" src="${src}" alt="${alt}">`;
        galleryThumbs.forEach((t) => t.classList.remove('product-gallery__thumb--active'));
        thumb.classList.add('product-gallery__thumb--active');
      });
    });
  }

  // ─── Variant selection (single variant select syncs price) ──
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect && productForm) {
    variantSelect.addEventListener('change', () => {
      const opt = variantSelect.options[variantSelect.selectedIndex];
      if (!opt) return;
      const variantId = opt.value;
      const price = opt.dataset.price;
      const compareAt = opt.dataset.compareAt;
      const available = opt.dataset.available === 'true';

      const idInput = productForm.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;

      const priceEl = document.querySelector('[data-product-price]');
      if (priceEl && price) priceEl.textContent = price;

      const compareEl = document.querySelector('[data-product-compare-at]');
      if (compareEl) {
        if (compareAt) {
          compareEl.textContent = compareAt;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      const submit = productForm.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !available;
        submit.innerHTML = available ? submit.dataset.labelDefault || 'Ajouter au panier' : 'Épuisé';
      }
    });
  }

  // ─── Language switcher (top bar dropdown) ──────────────────
  // S'attache après que le DOM soit prêt (script peut être chargé avant le HTML)
function initLangSwitcher() {
  const switcher = document.querySelector('[data-lang-switcher]');
  if (!switcher) return;

  const trigger = switcher.querySelector('[data-lang-trigger]');
  const menu = switcher.querySelector('[data-lang-menu]');
  if (!trigger || !menu) return;

  // Sort le menu du header pour échapper à tout contexte parent
  document.body.appendChild(menu);

  // Style de base : invisible mais mesurable
  menu.style.transition = 'opacity 0.15s ease, transform 0.15s ease';

  function positionMenu() {
    const rect = trigger.getBoundingClientRect();
    menu.style.top = (rect.bottom + 6) + 'px';
    let left = rect.right - menu.offsetWidth;
    const maxLeft = window.innerWidth - menu.offsetWidth - 8;
    if (left > maxLeft) left = maxLeft;
    if (left < 8) left = 8;
    menu.style.left = left + 'px';
  }

  function openMenu() {
    // 1. On rend visible le DOM mais transparent (pour mesurer sans flash)
    menu.hidden = false;
    menu.style.opacity = '0';
    menu.style.transform = 'translateY(-4px)';
    menu.style.visibility = 'hidden';

    // 2. On positionne (le navigateur a maintenant la bonne taille)
    positionMenu();

    // 3. On révèle proprement à la frame suivante
    requestAnimationFrame(() => {
      menu.style.visibility = 'visible';
      menu.style.opacity = '1';
      menu.style.transform = 'translateY(0)';
    });

    switcher.setAttribute('data-open', 'true');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    menu.style.opacity = '0';
    menu.style.transform = 'translateY(-4px)';
    switcher.setAttribute('data-open', 'false');
    trigger.setAttribute('aria-expanded', 'false');
    // On attend la fin de la transition pour cacher complètement
    setTimeout(() => {
      if (switcher.getAttribute('data-open') === 'false') {
        menu.hidden = true;
      }
    }, 150);
  }

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = switcher.getAttribute('data-open') === 'true';
    if (isOpen) closeMenu();
    else openMenu();
  });

  window.addEventListener('scroll', () => {
    if (switcher.getAttribute('data-open') === 'true') positionMenu();
  });
  window.addEventListener('resize', () => {
    if (switcher.getAttribute('data-open') === 'true') positionMenu();
  });

  document.addEventListener('click', (e) => {
    if (menu.contains(e.target)) return;
    if (switcher.contains(e.target)) return;
    if (switcher.getAttribute('data-open') === 'true') closeMenu();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && switcher.getAttribute('data-open') === 'true') {
      closeMenu();
    }
  });
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLangSwitcher);
  } else {
    initLangSwitcher();
  }

  // ─── Initialize cart count on page load ─────────────────────
  fetchCart().catch(() => {
    /* offline / cart endpoint failure — leave server-rendered count */
  });
})();

